<template>
    <div class="layout-article-page">

        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                  <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                  <h1 class="uk-margin-small-top">{{page.title}}</h1>
                
                  <slot name="summary">
                      <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                  </slot>

                  <slot name="subheader"></slot>
              </div>
            </div>
        </slot>

        <div class="uk-section uk-section-medium uk-background-white" v-if="page.content">
            <div class="uk-container uk-container-small">
                <div class="content" v-html="page.content"></div>
            </div>
        </div>

        <div class="uk-section uk-background-lightest uk-section-medium" v-if="!$apollo.loading && plans">
            <div class="uk-container">

                <h2><b>Lesson Plans</b> Available for Free Download:</h2>

                <template v-for="item in plans">
                    <h3>{{item.title}}</h3>
                    <div class="uk-card uk-card-default uk-margin-bottom">
                        <div class="uk-flex uk-grid-collapse" uk-grid>
                            <div class="uk-width-1-3@m uk-width1-2@l">
                                <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${item.image.smallSquare})`}" />
                            </div>
                            <div class="uk-width-2-3@m uk-width1-2@l">
                                <div class="uk-padding">
                                    <div class="content" v-html="item.content" />
                                    <a class="uk-button uk-button-primary" @click.stop="downloadPlan(item)" v-if="item.lessonPlanUrl && item.lessonPlanUrl">Download Lesson Plan</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

            </div>
        </div>

        <div id="download" class="uk-flex-top lesson-plan-modal uk-modal-container uk-background-white uk-dark" uk-modal>
            <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical" v-if="activeLessonPlan && activeLessonPlan.title">
                <button class="uk-modal-close-default uk-margin-small-top" type="button" uk-close></button>

                <div class="uk-flex uk-grid-collapse" uk-grid>
                    <div class="uk-width-1-2@m uk-width1-2@l">
                        <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${activeLessonPlan.image.smallSquare})`}" />
                    </div>
                    <div class="uk-width-1-2@m uk-width1-2@l">
                        <div class="uk-padding">

                            <div class="uk-alert-danger" uk-alert v-if="!!error">
                                <a class="uk-alert-close" uk-close></a>

                                <p>{{error}}</p>
                            </div>

                            <h2 class="uk-modal-title uk-margin-remove">{{activeLessonPlan.title}}</h2>
                            <template v-if="hideDownload">
                                <p class="uk-text-lead">Please subscribe or enter your information to download this lesson plan.</p>
                                <form action="https://lowellmilkencenter.us8.list-manage.com/subscribe/post?u=36b8acb32d8db6c72ab507565&amp;id=444509bbfe" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate v-on:submit.prevent="signup()">
                                    <div class="uk-margin">
                                        <input class="required email uk-input" type="email" name="EMAIL" id="mce-EMAIL" placeholder="Email*" required v-model="signupData.EMAIL">
                                    </div>
                                    <div class="uk-margin">
                                        <div class="uk-grid" uk-grid>
                                            <div class="uk-width-1-2@m">
                                                <input class="uk-input" type="text" name="FNAME" id="mce-FNAME" placeholder="First Name*" required v-model="signupData.FNAME">
                                            </div>
                                            <div class="uk-width-1-2@m">
                                                <input class="uk-input" type="text" name="LNAME" id="mce-LNAME" placeholder="Last Name*" required v-model="signupData.LNAME">
                                            </div>
                                        </div>
                                    </div>

                                    <input type="hidden" value="LP_Art_Project" name="CU_BONUS" class="" id="mce-CU_BONUS" />

                                    <div id="mce-responses" class="clear">
                                		<div class="response" id="mce-error-response" style="display:none"></div>
                                		<div class="response" id="mce-success-response" style="display:none"></div>
                                	</div> <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_36b8acb32d8db6c72ab507565_444509bbfe" tabindex="-1" value=""></div>

                                    <input type="hidden" name="LessonPlan" v-model="activeLessonPlan.title"  />

                                    <input class="uk-button uk-button-primary" type="submit" value="Subscribe and Download" name="subscribe" id="mc-embedded-subscribe" />
                                </form>
                                <p>After you have subscribed, your Download Link will appear here.</p>
                            </template>
                            <div class="uk-text-center uk-margin-top" v-else>
                                <p class="uk-text-lead uk-margin-bottom">{{message}}</p>
                                <a :href="activeLessonPlan.lessonPlanUrl" class="uk-button uk-button-primary uk-width-1-1" download><b>Download</b> the lesson plan</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />

    </div>
</template>
<script>
import gql from 'graphql-tag'
import _ from 'lodash'
import UIKit from 'uikit'
import axios from 'axios'

// GraphQL query
const readLessonPlansQuery = gql`{
      readLessonPlans{
            edges {
                node {
                    title
                    content
                    image {
                        medium
                        smallSquare
                    }
                    lessonPlanUrl
                }
            }
        }
    }
`

export default {
    inject: ['$cookies'],
    props: ['page', 'parent'],
    data() {
        return {
            plans: [],
            error: '',
            message: 'You are already a subscriber.',
            activeLessonPlan: {},
            hideDownload: !this.$cookies.get('subscribed'),
            signupData: {
                LISTID: "444509bbfe",
                FNAME: "",
                LNAME: "",
                EMAIL: "",
                CU_BONUS: "LP_Art_Project"
            }
        }
    },
    methods: {
        downloadPlan(activePlan) {
            this.activeLessonPlan = activePlan
            UIKit.modal('#download').show()
        },
        showDownload() {
            this.hideDownload = false
        },
        signup() {
            let vm = this
            axios.post('signup.php', {
                'LISTID': this.signupData.LISTID,
                'FNAME': this.signupData.FNAME,
                'LNAME': this.signupData.LNAME,
                'EMAIL': this.signupData.EMAIL,
                'CU_BONUS' : this.activeLessonPlan.title
            })
            .then(function (response) {
                // console.log("R", response);
                if(response.data.status == 'subscribed' || response.data.title == "Member Exists") {
                    vm.hideDownload = false
                    vm.$cookies.set('subscribed', true)
                    if(response.data.status == 'subscribed') {
                        vm.message = 'Thank you for subscribing!'
                    }
                }
                else {
                    vm.error = response.data.detail
                }
            })
            .catch(function (error) {
                this.error = error
            })

        }
    },
    apollo: {
        readLessonPlans: {
            query: readLessonPlansQuery,
            update(data) {
                this.plans = _.map(data.readLessonPlans.edges, "node")
            }
        }
    }
}
</script>
